import React from "react";
import PropTypes from 'prop-types';
import {
    HSA_SEARCH_FORM_DATES_ERROR,
    HSA_SEARCH_FORM_DESTINATION_ERROR,
    withTrackComponentDisplayed,
} from '../../../utils/HtmlEvents';
import { ABUtils } from '../../../utils';

const ErrorMessage = ({ errorMessage, dataTestId = "" }) => {
    const { isCssVariationMobile } = ABUtils.getABs();
    return isCssVariationMobile ? (
        <div className="prisma-labels odf-text-sm" data-testid={dataTestId}>
            <div className="odf-row-fluid odf-strong prisma-label-error">{errorMessage}</div>
        </div>
    ) : (
        <span className="odf-label odf-text-sm odf-space-outer-xs" data-testid={dataTestId}>
            {errorMessage}
        </span>
    );
};

ErrorMessage.propTypes = {
    errorMessage: PropTypes.string.isRequired,
    dataTestId: PropTypes.string,
}

export const DestinationErrorMessage = withTrackComponentDisplayed(ErrorMessage, HSA_SEARCH_FORM_DESTINATION_ERROR);
export const DatesErrorMessage = withTrackComponentDisplayed(ErrorMessage, HSA_SEARCH_FORM_DATES_ERROR);
